'use client';

import React from 'react';
import * as S from './styles';
import Text from '@/components/atoms/Text';
import Badge from '@/components/atoms/Badge';
import { ProdutoHomeProps } from '../..';
import Imagem from '@/components/atoms/Imagem';
import { useTheme } from 'styled-components';

export default function ProdutoHomeDesktop(props: ProdutoHomeProps) {
  const {
    nome,
    imagem,
    slug,
    etiqueta,
    assinatura,
    categoria,
    style = {},
  } = props;

  const theme = useTheme();

  return (
    <S.Container
      style={style}
      onClick={() => {
        if (slug === 'xbox-game-pass-ultimate') {
          window.location.href = 'https://xbox.chippu.com.br/';
        } else {
          window.location.href = `/${assinatura ? 'assinatura' : 'produto'}/${slug}`;
        }
      }}
    >
      <S.ImageContainer>
        <Imagem
          descricaoImagem="pedidoAvulso"
          priority={true}
          imagemUrl={imagem}
          style={{
            borderRadius: theme.radius[4],
            overflowClipMargin: 'unset',
          }}
          propsNextImage={{
            unoptimized: true,
          }}
        />
      </S.ImageContainer>
      <S.ProdutoInfo>
        {categoria ? (
          <Text
            $size={2}
            $color="neutral"
            $weight="regular"
            $align="left"
            $highContrast={true}
            $text={categoria?.nome}
          />
        ) : null}
        <Text
          $size={2}
          $color="neutral"
          $weight="bold"
          $align="left"
          $highContrast={true}
          $text={nome}
        />
      </S.ProdutoInfo>
      {etiqueta ? (
        <S.EtiquetaContainer>
          <Badge
            $size={1}
            $rounded={false}
            $variant="solid"
            $color={etiqueta.corFundo}
            $highContrast={false}
            $text={etiqueta.descricao}
            $textColor={etiqueta.corTexto}
          />
        </S.EtiquetaContainer>
      ) : null}
    </S.Container>
  );
}
